<template>
  <div class="inline-flex space-x-2">
    <BaseButton type="button" small primary @click="addPackage"> Add Package </BaseButton>
    <BaseButton type="button" small primary @click="addProduct"> Add Product </BaseButton>
    <BaseButton type="button" small primary @click="addService"> Add Service </BaseButton>
    <Portal to="app-dialog" v-if="show">
      <ProductCustomizer
        :options="productCustomizerOptions"
        @product="onProductSelected"
        @closed="setShow(false)"
      />
    </Portal>
  </div>
</template>

<script>
import { uniqueId } from 'lodash-es';
import ProductCustomizer from 'Components/ProductCustomizer/Index.vue';

const PRODUCT_PACKAGE = 'package';
const PRODUCT_BASIC = 'basic';
const PRODUCT_SERVICE = 'service';

export default {
  components: {
    ProductCustomizer,
  },
  props: {
    defaultVatRate: {
      type: Number,
      default: 0,
    },
    parentOfferLineId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      productCustomizerOptions: {
        type: PRODUCT_BASIC,
      },
    };
  },
  methods: {
    setShow(value) {
      this.show = Boolean(value);
    },
    addPackage() {
      this.productCustomizerOptions.type = PRODUCT_PACKAGE;
      this.setShow(true);
    },
    addProduct() {
      this.productCustomizerOptions.type = PRODUCT_BASIC;
      this.setShow(true);
    },
    addService() {
      this.productCustomizerOptions.type = PRODUCT_SERVICE;
      this.setShow(true);
    },
    getProductId(product) {
      if (typeof product.serviceUuid === 'string') {
        return product.serviceUuid;
      }

      if (typeof product.productId === 'string') {
        return product.productId;
      }

      return product.id;
    },
    getProductType(product) {
      if (typeof product.serviceUuid === 'string') {
        return 'service';
      }

      if (typeof product.productId === 'string') {
        return 'basic';
      }

      return 'package';
    },
    convertProductToOfferLine(product, parentOfferLineId = null) {
      const prefix = 'offer_line_';
      const id = uniqueId(prefix);

      return {
        _uuid: id,
        description: product.name,
        supplementaryDescription: product.description,
        pricePerUnit: product.price,
        quantity: 1,
        vatRate: this.defaultVatRate,
        productId: this.getProductId(product),
        ...(parentOfferLineId === null || parentOfferLineId.indexOf(prefix) === -1
          ? {
              parentOfferLineId,
            }
          : { _parentOfferLineId: parentOfferLineId }),
      };
    },
    convertProductToOfferLines(product, parentOfferLineId = null) {
      let offerLines = [];

      const { packageItems, productServices, ...restProperites } = product;

      const offerLine = this.convertProductToOfferLine(restProperites, parentOfferLineId);

      // eslint-disable-next-line no-underscore-dangle
      const uuid = offerLine._uuid || null;

      offerLines.push(offerLine);

      if (Array.isArray(packageItems) && packageItems.length > 0) {
        offerLines = [
          ...offerLines,
          ...packageItems.reduce(
            (carry, packageItem) => [
              ...carry,
              ...this.convertProductToOfferLines(packageItem, uuid),
            ],
            []
          ),
        ];
      }

      if (Array.isArray(productServices) && productServices.length > 0) {
        offerLines = [
          ...offerLines,
          ...productServices.reduce(
            (carry, productService) => [
              ...carry,
              ...this.convertProductToOfferLines(productService, uuid),
            ],
            []
          ),
        ];
      }

      return offerLines;
    },
    onProductSelected(product) {
      const offerLines = this.convertProductToOfferLines(product, this.parentOfferLineId);

      this.$emit('insert', offerLines);
    },
  },
};
</script>
